import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import FaqsPage from "@/pages/FaqsPage";
import ContactPage from "@/pages/ContactPage";
import CalculatorPage from "@/pages/CalculatorPage";
import MortgagePage from "@/pages/MortgagePage";
import HomeInsurancePage from "@/pages/HomeInsurancePage";
import ProtectionPage from "@/pages/ProtectionPage";
import HelpToBuyPage from "@/pages/HelpToBuyPage";
import RightToBuyPage from "@/pages/RightToBuyPage";
import RightToAcquirePage from "@/pages/RightToAcquirePage";
import SharedOwnershipPage from "@/pages/SharedOwnershipPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/services/mortgage" element={<MortgagePage />} />
          <Route path="/services/home-insurance" element={<HomeInsurancePage />} />
          <Route path="/services/protection" element={<ProtectionPage />} />
          <Route path="/schemes/help-to-buy" element={<HelpToBuyPage />} />
          <Route path="/schemes/right-to-buy" element={<RightToBuyPage />} />
          <Route path="/schemes/right-to-acquire" element={<RightToAcquirePage />} />
          <Route path="/schemes/shared-ownership" element={<SharedOwnershipPage />} />
          <Route path="/calculator" element={<CalculatorPage />} />
          <Route path="/faqs" element={<FaqsPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
